import { upNavRoutePaths } from "~/constants/upNavRouteConfig.ts";
export function IsUnauthenticatedRoute(route: string) {
  const unauthenticatedRoutes = [
    "/password/edit",
    "/expired",
    "/logout",
    "/no-access",
    upNavRoutePaths.monitorUpsell.path,
  ];

  return unauthenticatedRoutes.includes(route);
}
